import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb, Modal, ProgressBar } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { BsCheck, BsFillSquareFill } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { EventContext, LoaderContext } from '../../../../App';
import { EventType, LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY, LS_SELECTED_MAT_ISSUE_YEAR, STATUS, currentYear, startYear } from '../../../../core/constants/common';
import MaterialIssueService from '../../../../core/service/MaterialIssueService';
import ReportService from '../../../../core/service/ReportService';
import Utils from '../../../../core/utilities/Utils';
import './MaterialityAssessment.scss';
import useDoubleMatHelper from '../../../../core/hooks/useDoubleMatHelper';
import { BiChevronRight } from "react-icons/bi";


const OverviewMateriality = ({ t }) => {
	const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsDat.profile.company.id;
	const companyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
	const selectedYear = localStorage.getItem(LS_SELECTED_MAT_ISSUE_YEAR) ?? null
	const yearOptions = [];
	const year = new Date().getFullYear();
	for (let i = currentYear; i >= startYear; i--) {
		yearOptions.push(<option value={i} key={i}>{i}</option>);
	}
	const [filter, setFilter] = useState({
		year: selectedYear ?? `${year}`,
		category: ''
	});
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [statusCount, setStatusCount] = useState({});
	const [percentage, setPercentage] = useState(0);
	const navigate = useNavigate();
	const [stats, setStats] = useState({});
	const [reports, setReports] = useState([]);
	const [showMethodology, setShowMethodology] = useState(false);
	const [totalWeightage, setTotalWeightage] = useState(0);
	const { setEvent } = useContext(EventContext);
	const {
		isSurveyCompleted
	} = useDoubleMatHelper();
	const [version, setVersion] = useState({});
	const lsCompanyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY));
	const [materialityType, setMaterialityType] = useState(lsCompanyInfo.materialityType == 'SINGLE' ? 'Impact Materiality' : 'Double Materiality');

	useEffect(() => {
		localStorage.setItem(LS_SELECTED_MAT_ISSUE_YEAR, filter.year);
		getStats();
		getRecentReports();
	}, [filter]);

	const getStats = () => {
		setLoaderDisplay(true)
		MaterialIssueService.getStats(companyId, filter.year, companyInfo.materialTopicCategory ?? 'GENERAL').then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;
			setupMatOverviewStats(res.data);
			setVersion(res.data.issueProgress.version);
		}).catch(err => {
			setLoaderDisplay(false)
		});
	};

	const getRecentReports = () => {
		// Fetch only the 2 most recent reports
		ReportService.listReports(
			0,
			2,
			'',
			companyId,
			'',
			'DOUBLE_MATERIALITY',
			filter.year
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setReports(res.data);
		}).catch(err => {
			setLoaderDisplay(false)
		});
	};

	const calcPercentage = (data) => {
		const selected = data.selectedCount;
		const omitted = data.omittedCount;
		const library = data?.version?.status == 'FINALIZED' ? data?.finalLibraryCount : data?.libraryCount;
		const p = ((selected + omitted) / library) * 100
		setPercentage(p);
		return p;
	}

	const gotoIssues = () => {
		navigate("/company_admin/dmat/issues" + `?year=${filter.year}&type=edit&tab=library`);
	};


	const renderSummaryCard = () => {
		return (
			<div className='OverviewrenderSummaryCard021'>
				<ul>
					<li className='Total'>
						<div className='fw-bold'>{statusCount?.version?.status == 'FINALIZED' ? statusCount?.finalLibraryCount : statusCount?.libraryCount}</div>
						<div> {t("Total.label")}</div>
					</li>
					<li className='Selected'>
						<BsFillSquareFill />
						<div className='fw-bold'>{statusCount?.selectedCount ?? 0}</div>
						<div>{t("Selected.label")} </div>
					</li>
					<li className='Omitted'>
						<BsFillSquareFill />
						<div className='fw-bold'> {statusCount?.omittedCount ?? 0}</div>
						<div>{t("Omitted.label")}</div>
					</li>
					<li className='Pending'>
						<BsFillSquareFill />
						<div className='fw-bold'>{(statusCount?.version?.status == 'FINALIZED' ? statusCount?.finalLibraryCount : statusCount?.libraryCount) - (statusCount?.selectedCount + statusCount?.omittedCount)}</div>
						<div>{t("Pending.label")}</div>
					</li>
				</ul>
			</div>
		);
	};

	const renderSurveyCard = () => {
		if (stats?.assessment?.id) {
			return (
				// <AssessmentListCard key={`survey-overview-card`}
				// 	form={stats?.assessment}
				// 	formType={FormType.SURVEY}
				// 	viewMode='OVERVIEW_CARD'
				// 	selfAssessment={true}
				// />
				<div className="Overviewrendersurvey021">
					<ul>
						<li className='Submitted'>
							<BsFillSquareFill />
							<div>
								<b className='me-1'>{stats?.assessment.submissionStatusCount?.COMPLETED ?? 0}</b>
								{t("Submitted.label")}
							</div>
						</li>
						<li className='InProgress'>
							<BsFillSquareFill />
							<div>
								<b className='me-1'>
									{(stats?.assessment.submissionStatusCount?.IN_PROGRESS ?? 0)
										+ (stats?.assessment.submissionStatusCount?.CORRECTION_PENDING ?? 0) + (stats?.assessment.submissionStatusCount?.PENDING_APPROVAL ?? 0)}
								</b>
								{t("InProgress.label")}
							</div>
						</li>
						<li className='NotStarted'>
							<BsFillSquareFill />
							<div>
								<b className='me-1'>{stats?.assessment.submissionStatusCount?.DRAFT ?? 0}</b>
								{t("NotStarted.label")}
							</div>
						</li>
						<li className='NotShared'>
							<BsFillSquareFill />
							<div>
								<b className='me-1'>{stats?.assessment.submissionStatusCount?.NOT_SHARED ?? 0}</b>
								{t("NotShared.label")}
							</div>
						</li>
					</ul>
				</div>
			);
		}

	};

	const renderStakeholderCard = () => {
		if (!stats?.stakeholder) return <></>;
		return (
			<div className='OverviewStakeholderCard021'>
				<div className='row m-0'>
					<div className='col-lg-3 p-2'>
						{renderStakeholderSplitInfo()}
					</div>
					<div className='col-lg-9 p-2'>
						{renderStakeholderWeightage()}
					</div>
				</div>

			</div>
		)
	};

	const renderStakeholderSplitInfo = () => {
		return (
			<>
				<div className='stakholdersCountAll02'>
					<ul>
						<li>
							<b>{stats.stakeholder.totalStakeholders ?? 0}</b> <span> {t("Total.label")}</span>
						</li>
						<li>
							<b>{stats.stakeholder.stakeholderTypeCounts.EXTERNAL ?? 0}</b> <span> {t("External.label")} </span>
						</li>
						<li >
							<b>{stats.stakeholder.stakeholderTypeCounts.INTERNAL ?? 0}</b> <span>{t("Internal.label")}</span>
						</li>
					</ul>
				</div>
			</>
		)
	};

	const renderStakeholderWeightage = () => {
		const progressBarColors = Utils.getDynamicProgressBarColors(stats.stakeholder.weightageDistribution ?? {});
		return (
			<>
				<h6 className='mb-3'>{t('Weightage.label')}</h6>
				<div>
					<ProgressBar>
						{Object.keys(stats.stakeholder.weightageDistribution ?? {}).map((key, index) => (
							<ProgressBar
								key={key}
								style={{ backgroundColor: progressBarColors[key] }}
								now={stats.stakeholder.weightageDistribution[key].weightage ?? 0}
								label={''}
							/>
						))}
					</ProgressBar>
					<div className='SummaryIssueCard_Weightage 5'>
						<ul>
							{Object.keys(stats.stakeholder.weightageDistribution ?? {}).map((key, index) => (
								<>
									{
										stats.stakeholder.weightageDistribution[key].weightage &&
										<li >
											<span className='me-2'><BsFillSquareFill style={{ color: progressBarColors[key] }} />
												{stats.stakeholder.weightageDistribution[key].weightage} %</span>
											{stats.stakeholder.weightageDistribution[key].name}
										</li>
									}
								</>
							))}
						</ul>
					</div>
				</div>
			</>
		)
	};

	const renderShortlistedIssuesCard = () => {
		return (
			<div className='OverViewTotalScoreIssue'>
				{stats.scorecard?.shortListedIssues?.length > 0 && (
					<h5>
						{t('Total.label')} {stats.scorecard?.shortListedIssues?.length} {t("ShortlistedIssues.label")}
					</h5>
				)}
				<ul>

					{
						stats.scorecard?.shortListedIssues?.map((issue, index) => {
							return (
								<li className='fw-normal' key={`shortlisted-issue-${index}`}>
									{/* <span>{issue.rankingByCompany}.</span>  */}
									{issue.topic?.name}
								</li>
							);
						})
					}
				</ul>
			</div>
		)
	};

	const rednerReportsCard = () => {
		return (
			<div className='rednerReportsCard021'>
				<div className='row m-0'>
					{
						reports?.map((report, index) => {
							return (

								<div className="col-md-4 p-1" key={`recentReport-${index}`}>
									<div className="recent_ReportBox">
										<div className="recent_ReportBox_in">
											<h6 className="mb-0">{report?.name ?? ''}</h6>
										</div>
										<div className="recent_ReportBox_dt">
											<small className="me-2">{Utils.formatDateAsDaysAgo(report?.lastModifiedDate)}</small>
										</div>
									</div>
								</div>
							);
						})
					}
				</div>
			</div>
		);
	};

	const renderStakeholderProgressCard = () => {
		return (
			<div className={`FivestepStatusCardDtRow ${stats?.statusInfo?.stakeholder?.bubbleClass}`}>
				<div className='row FivestepStatusCardDtRow02  m-0'>
					<span className='stepStatusCount number'>1</span>
					<span className='stepStatusCount checkIcon'><BsCheck /></span>
					<div className='col-md-2 FivestepStatusCardDt p-2 '>

					<div className='mb-1 FSSCData' onClick={() => navigate("../stakeholders")} >
						<a href='#' onClick={(e) => e.preventDefault()}>{t("MapStakeholders.label")}</a>
					</div>
						<span className={`badge ${stats?.statusInfo?.stakeholder?.badge} rounded-pill`}>
							{stats?.statusInfo?.stakeholder?.label}
						</span>
					</div>
					<div className='col-md-4 p-2'>
						<ul>
							<li>{t("OverViewStakeholderMessage.label")}</li>
							<li>{t("OverViewStakeholderMessage2.label")}</li>
						</ul>
					</div>
					<div className='col-md-6 p-0 '>
						{renderStakeholderCard()}
					</div>
				</div>
			</div>
		);
	};

	const renderIssueProgressCard = () => {
		return (
			<div className={`FivestepStatusCardDtRow ${stats?.statusInfo?.issue?.bubbleClass}`}>
				<div className='row  FivestepStatusCardDtRow02 m-0'>

					<span className='stepStatusCount number'>2</span>
					<span className='stepStatusCount checkIcon'><BsCheck /></span>

					<div className='col-md-2 FivestepStatusCardDt p-2 '>

						<div className='mb-1 FSSCData' onClick={() => navigate("../issues")}>
							{t("IdentifyMaterialIssues.label")}
						</div>
						<span className={`badge ${stats?.statusInfo?.issue?.badge} rounded-pill`}>
							{stats?.statusInfo?.issue?.label}
						</span>
					</div>
					<div className='col-md-4 p-2'>
						<ul>
							<li>{t("OverviewMaterialIssuesLibrary.label")}</li>
							<li>{t("OverviewMaterialIssuesLibrary2.label")}</li>
						</ul>
					</div>
					<div className='col-md-6 p-2 '>
						{renderSummaryCard()}
					</div>
				</div>
			</div>
		);
	};

	const renderSurveyProgressCard = () => {
		return (
			<div className={`FivestepStatusCardDtRow ${stats?.statusInfo?.survey?.bubbleClass}`}>
				<div className='row FivestepStatusCardDtRow02 m-0'>
					<span className='stepStatusCount number'>3</span>
					<span className='stepStatusCount checkIcon'><BsCheck /></span>
					<div className='col-md-2 FivestepStatusCardDt p-2 '>

						<div className='mb-1 FSSCData' onClick={() => navigate("../matassessments")}>
							{t("ConductMaterialityAssessmentSurvey.label")}
						</div>
						<span className={`badge ${stats?.statusInfo?.survey?.badge} rounded-pill`}>
							{stats?.statusInfo?.survey?.label}
						</span>
					</div>
					<div className='col-md-4 p-2'>
						<ul>
							<li>{t("OverviewCreateDistributeSurvey.label")}</li>
							<li>{t("OverviewCreateDistributeSurvey2.label")}</li>
						</ul>
					</div>
					<div className='col-md-6 p-2 '>
						{renderSurveyCard()}
					</div>
				</div>
			</div>
		);
	};

	const renderScorecardProgressCard = () => {
		return (
			<div className={`FivestepStatusCardDtRow ${stats?.statusInfo?.scorecard?.bubbleClass}`}>
				<div className='row FivestepStatusCardDtRow02 m-0'>
					<span className='stepStatusCount number'>4</span>
					<span className='stepStatusCount checkIcon'><BsCheck /></span>
					<div className='col-md-2 FivestepStatusCardDt p-2 '>

						<div className='mb-1 FSSCData' onClick={() => navigate("../scorecard/default")}>
							{t("FinalizeScoreCards.label")}
						</div>
						<span className={`badge ${stats?.statusInfo?.scorecard?.badge} rounded-pill`}>
							{stats?.statusInfo?.scorecard?.label}
						</span>
					</div>
					<div className='col-md-4 p-2'>
						<ul>
							<li>{t("OverviewScoringAnalysis.label")}</li>
							<li>{t("OverviewScoringAnalysis2.label")}</li>
							<li>{t("OverviewScoringAnalysis3.label")}</li>
						</ul>
					</div>
					<div className='col-md-6 p-2 '>
						{renderShortlistedIssuesCard()}
					</div>
				</div>
			</div>
		);
	};

	const renderReportProgressCard = () => {
		return (
			<div className={`FivestepStatusCardDtRow ${stats?.statusInfo?.report?.bubbleClass}`}>
				<div className='row FivestepStatusCardDtRow02 m-0'>
					<span className='stepStatusCount number'>5</span>
					<span className='stepStatusCount checkIcon'><BsCheck /></span>
					<div className='col-md-2 FivestepStatusCardDt p-2 '>
						<div className='mb-1 FSSCData' onClick={() => navigate("../scorecard/default")}>
							{t("DraftMaterialityReport.label")}
						</div>
						<span className={`badge ${stats?.statusInfo?.report?.badge} rounded-pill`}>
							{stats?.statusInfo?.report?.label}
						</span>
					</div>
					<div className='col-md-4 p-2'>
						<ul>
							<li>{t("OverviewMaterialityReportGen.label")}</li>
							<li>{t("OverviewMaterialityReportGen2.label")}</li>
						</ul>
					</div>
					<div className='col-md-6 p-2 '>
						{rednerReportsCard()}
					</div>
				</div>
			</div>
		);
	};

	const setupMatOverviewStats = (statsData) => {
		let sum = 0;
		const weightageDistribution = statsData.stakeholder.weightageDistribution;
		for (const key in weightageDistribution) {
			const weightage = weightageDistribution[key].weightage;
			if (weightage !== null && !isNaN(weightage)) {
				sum += weightage;
			}
		}
		setTotalWeightage(sum);
		setStatusCount(statsData.issueProgress);
		const p = calcPercentage(statsData.issueProgress);
		let inProgressCount = 0;
		let notStartedCount = 0;
		let completedCount = 0;
		// Stakeholder status
		let stakeholderStatus = {};
		if (statsData?.stakeholder?.totalStakeholders > 0 && sum >= 100) {
			stakeholderStatus = {
				badge: 'bg-badge-Finalized',
				label: t("Completed.label"),
				bubbleClass: 'done'
			};
			completedCount++;
		} else if (statsData?.stakeholder?.totalStakeholders > 0 && sum < 100) {
			stakeholderStatus = {
				badge: 'bg-badge-Inprogress',
				label: t("Inprogress.label"),
				bubbleClass: 'selectStep'
			};
			inProgressCount++;
		} else {
			stakeholderStatus = {
				badge: 'bg-badge-New',
				label: t("NotStarted.label"),
				bubbleClass: ''
			};
			notStartedCount++;
		}
		// Issue status
		let issueStatus = {};
		if (statsData.issueProgress?.version?.status == 'FINALIZED') {
			issueStatus = {
				bubbleClass: 'done'
			};
		} else if (statsData.issueProgress?.version?.status == 'DRAFT' && p <= 100) {
			issueStatus = {
				bubbleClass: 'selectStep'
			};
		} else {
			issueStatus = {
				bubbleClass: ''
			};
		}
		issueStatus = {
			...issueStatus,
			badge: 'bg-badge-New',
			label: t("NotStarted.label"),
		};
		if (statsData.issueProgress?.version?.status == 'DRAFT' && p == 100) {
			issueStatus = {
				...issueStatus,
				badge: 'bg-badge-Finalized',
				label: t("Completed.label"),
			};
			inProgressCount++;
		} else if (statsData.issueProgress?.version?.status == 'DRAFT' && p < 100) {
			issueStatus = {
				...issueStatus,
				badge: 'bg-badge-Inprogress',
				label: t("Inprogress.label"),
			};
			inProgressCount++;
		} else if (statsData.issueProgress?.version === null) {
			issueStatus = {
				...issueStatus,
				badge: 'bg-badge-New',
				label: t("NotStarted.label"),
			};
			notStartedCount++;
		} else if (statsData.issueProgress?.version?.status == 'FINALIZED') {
			issueStatus = {
				...issueStatus,
				badge: 'bg-success',
				label: t("Finalized.label"),
			};
			completedCount++;
		}
		// Srurvey status
		let surveyStatus = {};
		if (isSurveyCompleted(statsData)) {
			surveyStatus = {
				badge: 'bg-badge-Finalized',
				label: t("Completed.label"),
				bubbleClass: 'done'
			};
			completedCount++;
		} else if (statsData?.assessment) {
			surveyStatus = {
				badge: 'bg-badge-Inprogress',
				label: t("Inprogress.label"),
				bubbleClass: 'selectStep'
			};
			inProgressCount++;
		} else {
			surveyStatus = {
				badge: 'bg-badge-New',
				label: t("NotStarted.label"),
				bubbleClass: ''
			};
			notStartedCount++;
		}
		// Scorecard status
		let scorecardStatus = {};
		if (statsData?.scorecard?.statusCounts?.FINALIZED > 0) {
			scorecardStatus = {
				badge: 'bg-badge-Finalized',
				label: t("Completed.label"),
				bubbleClass: 'done'
			};
			completedCount++;
		} else if (statsData?.scorecard?.statusCounts?.DRAFT > 0) {
			scorecardStatus = {
				badge: 'bg-badge-Inprogress',
				label: t("Inprogress.label"),
				bubbleClass: 'selectStep'
			};
			inProgressCount++;
		} else {
			scorecardStatus = {
				badge: 'bg-badge-New',
				label: t("NotStarted.label"),
				bubbleClass: ''
			};
			notStartedCount++;
		}
		// Report status
		let reportStatus = {};
		if (statsData?.scorecard?.statusCounts?.REPORT_COUNT > 0) {
			reportStatus = {
				badge: 'bg-badge-Finalized',
				label: t("Completed.label"),
				bubbleClass: 'done'
			};
			completedCount++;
		} else if ((statsData?.scorecard?.statusCounts?.DRAFT + statsData?.scorecard?.statusCounts?.FINALIZED) > 0) {
			reportStatus = {
				badge: 'bg-badge-Inprogress',
				label: t("Inprogress.label"),
				bubbleClass: 'selectStep'
			};
			inProgressCount++;
		} else {
			reportStatus = {
				badge: 'bg-badge-New',
				label: t("NotStarted.label"),
				bubbleClass: ''
			};
			notStartedCount++;
		}
		setStats({
			...statsData,
			statusInfo: {
				stakeholder: stakeholderStatus,
				issue: issueStatus,
				survey: surveyStatus,
				scorecard: scorecardStatus,
				report: reportStatus,
				overallStatus: {
					badge: completedCount >= 5 ? 'bg-badge-Finalized' : notStartedCount >= 5 ? 'bg-badge-New' : 'bg-badge-Inprogress',
					label: completedCount >= 5 ? t("Completed.label") : notStartedCount >= 5 ? t("NotStarted.label") : t("Inprogress.label")
				}
			}
		});
	};

	return (
		<div className='OverviewMateriality'>
			<div className="List_header mb-1">
				<div>
					<Breadcrumb className='h5'>
						<Breadcrumb.Item>{t("Materiality.label")}</Breadcrumb.Item>
						<Breadcrumb.Item active>{t("Overview.label")}</Breadcrumb.Item>
					</Breadcrumb>
				</div>
				<div className='header-actions'>
					<span className="badge bg-badge-Accepted rounded-pill">{version ? version?.materialityType == 'SINGLE' ? 'Impact Materiality' : 'Double Materiality' : materialityType}</span>
					<select className="form-select  w-auto" value={filter.year}
						onChange={(e) => {
							setFilter({ ...filter, year: e.target.value });
							setEvent({
								event: EventType.DOUBLE_MAT_YEAR_CHANGED,
								data: { year: e.target.value },
							});
						}}>
						{yearOptions}
					</select>
				</div>
			</div>
			<div className='row m-0'>
				<div className='col-lg-12 px-0 py-2'>
					<div className='OverviewMateriality_head'>
						<div className='OV_headInner'>
							<h6>{t("MaterialAssessmentProcessStatus.label")} {filter.year} </h6>
							{/* <BsInfoCircle /> */}
							<span className={`badge ${stats?.statusInfo?.overallStatus?.badge} rounded-pill`}>
								{stats?.statusInfo?.overallStatus?.label}
							</span>
						</div>
						<span className='btn btn-light btn-sm border' onClick={() => setShowMethodology(true)}>{t("Methodology.label")} <BiChevronRight /></span>
					</div>
				</div>
				<div className='col-md-12 p-0'>
					<div className='FivestepStatusCard'>
						<div className='FivestepStatusCard_body'>
							{renderStakeholderProgressCard()}
							{renderIssueProgressCard()}
							{renderSurveyProgressCard()}
							{renderScorecardProgressCard()}
							{renderReportProgressCard()}
						</div>
					</div>
				</div>
			</div>

			<Modal show={showMethodology}
				onHide={() => setShowMethodology(false)}
				aria-labelledby="contained-modal-title-vcenter"
				size="lg"
				centered>
				<Modal.Header closeButton>
					<Modal.Title as="h5">
						{t("MethodologyTexts.MethodologyHeader")}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className='pt-0'>
					<div className='col-lg-12 p-2'>
						<div className='methodologyCard'>

							<div className='methodologyCard_body'>
								<div>
									<h6>1. {t("MethodologyTexts.MethodologySubHead1")}</h6>
									<ul>
										<li>{t("MethodologyTexts.MethodologySub1a")}</li>
										<li>{t("MethodologyTexts.MethodologySub1b")}</li>
										<li>{t("MethodologyTexts.MethodologySub1c")}</li>
									</ul>
								</div>
								<div>
									<h6>2. {t("MethodologyTexts.MethodologySubHead2")}</h6>
									<ul>
										<li>{t("MethodologyTexts.MethodologySub2a")}</li>
										<li>{t("MethodologyTexts.MethodologySub2b")}</li>
										<li>{t("MethodologyTexts.MethodologySub2c")}</li>
									</ul>
								</div>

								<h6>3. {t("MethodologyTexts.MethodologySubHead3")}</h6>

								<ul>
									<li>{t("MethodologyTexts.MethodologySub3a")}</li>
									<li>{t("MethodologyTexts.MethodologySub3b")}</li>
									<li>{t("MethodologyTexts.MethodologySub3c")}</li>
									<li>{t("MethodologyTexts.MethodologySub3d")}</li>
								</ul>
								<h6>4. {t("MethodologyTexts.MethodologySubHead4")}</h6>

								<ul>
									<li>{t("MethodologyTexts.MethodologySub4a")}</li>
									<li>{t("MethodologyTexts.MethodologySub4b")}</li>
									<li>{t("MethodologyTexts.MethodologySub4c")}</li>
									<li>{t("MethodologyTexts.MethodologySub4d")}</li>
								</ul>
								<h6>5. {t("MethodologyTexts.MethodologySubHead5")}</h6>

								<ul>
									<li>{t("MethodologyTexts.MethodologySub5a")}</li>
									<li>{t("MethodologyTexts.MethodologySub5b")}</li>
									<li>{t("MethodologyTexts.MethodologySub5c")}</li>
									<li>{t("MethodologyTexts.MethodologySub5d")}</li>
								</ul>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</div >
	)
};
export default withTranslation()(OverviewMateriality);